import { AppState, IndexPagePaphosAppState } from '../../../initialStateRegistration';

export const getIndexPage = (state: AppState) => (state as IndexPagePaphosAppState).template;
